// Constants for AboutCompanyOverview component
export const SECTION_TITLES = {
    OVERVIEW: 'Overview',
    COMPANY_SECTOR: 'Company Sector:',
};

export const BOX_TITLES = {
    PRODUCT_OFFERINGS: 'Product Offerings',
    CUSTOMERS_AND_SALES_CHANNELS: 'Customers & Sales Channels',
    VENDORS_SOURCING_MANUFACTURING: 'Vendors, Sourcing & Manufacturing',
    GEOGRAPHIES_SEGMENTATION: 'Geographies & Segmentation',
    COMPETITORS_OR_LISTED_PEER: 'Competitors & Listed Peers',
    SECTORAL_PERFORMANCE: 'Sectoral Performance',
};

export const INVESTOR_LABELS = {
    SINGLE: 'Key Investor:',
    MULTIPLE: 'Key Investors:',
};

export const FUNDING_LABEL = 'Funding Raised:';
